import * as React from 'react';
import * as ReactDOM from 'react-dom';
import useEffect from '../../utils/use_effect';
import propTypes from './prop_types';
import { jsx as ___EmotionJSX } from "@emotion/react";
function getContainer(container) {
  return container ? typeof container === 'function' ? container() : container : null;
}
var Portal = _ref => {
  var {
    children,
    container,
    disablePortal = false
  } = _ref;
  var [portalNode, setPortalNode] = React.useState();
  useEffect(() => {
    if (disablePortal) return;
    setPortalNode(getContainer(container) || document.body);
  }, [container, disablePortal]);
  if (disablePortal) {
    return ___EmotionJSX(React.Fragment, null, children);
  }
  return portalNode ? /*#__PURE__*/ReactDOM.createPortal(children, portalNode) : ___EmotionJSX(React.Fragment, null);
};
Portal.propTypes = propTypes;
Portal.displayName = 'Portal';

// Recast to remove propTypes from exported type for react 19 compatibility
export default Portal;